<div
  class="{{ class }}"
  #target
  [ngClass]="{
    'plan-subscriptions': isSubscriptionPlans,
    'not-plan-subscriptions': !isSubscriptionPlans,
    light: !isSelectedPlan && isSubscriptionPlans,
    selected: isSelectedPlan
  }"
>
  <div class="flex justify-content-center head-container">
    <div *ngIf="company" [ngClass]="class + '__company'">
      <lib-tag [title]="company"></lib-tag>
    </div>
  </div>

  <div [ngClass]="class + '__header'">
    <p class="h3 text-primary-color mb-3" *ngIf="!isSubscriptionPlans; else headingH1">
      {{ plan.planType }}
    </p>

    <ng-template #headingH1>
      <p class="h4 mb-3">
        {{ plan.subDisplayName }}
      </p>
    </ng-template>
    <div>
      <ng-container *ngIf="!isSubscriptionPlans; else headingH2">
        <div class="flex align-items-center">
          <h2 class="text-primary-color">{{ planCalculatorService.getSubtotal(plan) | euroCurrency }}</h2>
          <div class="flex-column">
            <p *ngIf="cloudVersion" class="text-bold ml-2">
              +{{ planCalculatorService.getCloudVersionCost(plan.cloudVersion, plan.workStationCount) }}€ Cloud Version
            </p>
            <p *ngIf="devicesCount !== 0" class="text-bold ml-2">
              + {{ planCalculatorService.getTotalDeviceCost(devicesCount) | euroCurrency }} {{ devicesCount }}
              {{ (devicesCount | pluralize : 'device').replace('zusätzliche', '').replace(' s', '') }}
            </p>
          </div>
        </div>
      </ng-container>
      <ng-template #headingH2>
        <h3 class="text-dark-grey">
          {{ planCalculatorService.getSubtotal(plan) | euroCurrency }}
        </h3>
      </ng-template>
    </div>
    <p class="text-dark-grey mb-3">{{ frontPage.planSelector.perMonth }}</p>
    <label *ngIf="!isSubscriptionPlans" for="buttondisplay" class="text-bold required">
      {{ frontPage.planSelector.calendar.changeDateText.existingCustomer }}
    </label>
    <div class="{{ class + '__input mt-2' }}">
      <p-calendar
        #calendar
        *ngIf="!isSubscriptionPlans"
        view="month"
        [(ngModel)]="startDate"
        [showIcon]="true"
        [showOnFocus]="false"
        inputId="buttondisplay"
        dateFormat="MM y"
        (input)="formatInputDate($event)"
        (onSelect)="handleDateSelect($event)"
        [placeholder]="frontPage.planSelector.calendar.placeHolder"
        [minDate]="minMonth"
        (onShow)="onShow()"
        (onYearChange)="removeCurrentMonthStyle()"
      ></p-calendar>

      <p-button
        (click)="btnClicked()"
        label="Show"
        [label]="buttonLabel"
        [icon]="isSelectedPlan ? 'pi pi-check' : 'pi pi-arrow-right'"
        iconPos="right"
        [class]="(isSelectedPlan ? 'p-button-outlined' : 'p-text-normal') + (!isSubscriptionPlans ? ' open-package-summary-btn' : '')"
        [disabled]="!startDate"
      />
      <p-dialog
        header=""
        [modal]="true"
        [(visible)]="visible"
        [style]="{ width: '1312px', height: '100vw' }"
        [draggable]="false"
        [resizable]="false"
      >
        <div class="{{ class + '__package-summary-dialog' }}">
          <package-summary-dialog></package-summary-dialog>
        </div>
      </p-dialog>
    </div>

    <p class="small-text text-red mt-1" *ngIf="startDateError && !isSubscriptionPlans">{{ frontPage.planSelector.calendar.noStartDate }}</p>
    <p class="small-text text-red mt-1" *ngIf="noResetDate && !isSubscriptionPlans">{{ frontPage.planSelector.calendar.noReset }}</p>
  </div>

  <div class="mt-4">
    <p class="mb-3 text-bold">{{ frontPage.planSelector.featuresHeader }}</p>

    <div class="{{ class + '__list' }}">
      <div *ngIf="!isSubscriptionPlans" class="{{ class + '__increment-decrement' }}">
        <div class="increment-decrement-container">
          <p-inputNumber
            inputId="workStation"
            [ngModel]="workStationCount"
            [showButtons]="true"
            [min]="0"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            currency="EUR"
            (ngModelChange)="handleWorkStationCountChange($event)"
            [disabled]="isSubscriptionPlans"
          ></p-inputNumber>
        </div>

        <label for="workStation">
          {{ workStationCount | pluralize : 'workStation' }}
          <br />
          {{ frontPage.planSelector.workStation.intro }} {{ planCalculatorService.getTotalWorkStationCostDisplay(plan) | euroCurrency }}
          {{ frontPage.planSelector.workStation.outro }}
        </label>
      </div>

      <div *ngIf="!isSubscriptionPlans" class="{{ class + '__increment-decrement' }}">
        <div class="increment-decrement-container">
          <p-inputNumber
            inputId="device"
            [(ngModel)]="devicesCount"
            [showButtons]="true"
            [min]="0"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            currency="EUR"
            (ngModelChange)="handleDevicesCountChange($event)"
            [disabled]="isSubscriptionPlans"
          ></p-inputNumber>
        </div>

        <label for="device">
          {{ devicesCount | pluralize : 'device' }}
          <br />
          {{ frontPage.planSelector.mobileDevices.intro }} {{ 4.9 | euroCurrency }}
          {{ frontPage.planSelector.mobileDevices.outro }}
        </label>
      </div>

      <div *ngIf="!isSubscriptionPlans" class="{{ class + '__increment-decrement  mb-3' }}">
        <div class="increment-decrement-container">
          <p-inputNumber
            inputId="client"
            [(ngModel)]="clientsCount"
            [showButtons]="true"
            [min]="0"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            (ngModelChange)="handleClientsCountChange($event)"
            currency="EUR"
            [disabled]="isSubscriptionPlans"
          ></p-inputNumber>
        </div>

        <label for="client">
          {{ clientsCount | pluralize : 'client' }}
          <br />
          {{ frontPage.planSelector.clients.intro }} {{ 20 | euroCurrency }}
          {{ frontPage.planSelector.clients.outro }}
        </label>
      </div>
    </div>

    <div class="mb-4" [ngClass]="{ 'top-input': !isSubscriptionPlans }">
      <ng-container *ngIf="!isSubscriptionPlans">
        <div class="flex align-items-center relative mb-4">
          <div class="pt-2">
            <p-inputSwitch [(ngModel)]="cloudVersion" (ngModelChange)="handleCloudVersionChange($event)" [disabled]="isSubscriptionPlans" />
          </div>
          <span class="ml-2 block">
            {{ frontPage.planSelector.cloudVersion.label }}
            {{ (plan.workStationCount > 0 ? planCalculatorService.getCloudVersionCost(true, plan.workStationCount) : 40) | euroCurrency }}
          </span>
        </div>
      </ng-container>
    </div>
    <ul *ngIf="plan.modules" class="{{ class + '__list' }}">
      <li class="{{ class + '__list-item' }}">
        <lib-list-item [text]="'Grundmodul ' + (plan.planType | basicModuleText)" [alignItemsCenter]="true"></lib-list-item>
      </li>
      <li class="{{ class + '__list-item' }}" *ngFor="let item of plan.modules">
        <lib-list-item [text]="item.name" icon="orange-check" [icon]="'check'"></lib-list-item>
      </li>
      <ng-container *ngIf="PLANS_HELPER.isL_PAKET(plan.planType)">
        <li class="{{ class + '__list-item' }}" *ngFor="let item of plan.additionalModules | slice : 0 : disableModules.length">
          <lib-list-item [text]="item.name" icon="orange-check" [icon]="'orange-check'"></lib-list-item>
        </li>
      </ng-container>
    </ul>

    <div
      class="mt-5 mb-3"
      *ngIf="(plan.additionalModules || []).length > (PLANS_HELPER.isL_PAKET(plan.planType) ? disableModules.length : 0)"
    >
      <ul *ngIf="plan.additionalModules" class="{{ class + '__list  mb-3' }}">
        <ng-container *ngFor="let item of plan.additionalModules; let i = index">
          <li *ngIf="PLANS_HELPER.isL_PAKET(plan.planType) && i >= disableModules.length" class="{{ class + '__list-item' }}">
            <lib-list-item
              [text]="item.name"
              icon="orange-check"
              [button]="true"
              (action)="handleListItemAction(item.id, item.name, item.price)"
            ></lib-list-item>
          </li>

          <li *ngIf="PLANS_HELPER.isM_PAKET(plan.planType)" class="{{ class + '__list-item' }}">
            <lib-list-item
              [text]="item.name"
              icon="plus"
              [button]="true"
              (action)="handleListItemAction(item.id, item.name, item.price)"
            ></lib-list-item>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
